import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityForm from '../../../components/forms/ActivityForm';
import { useActivityApi } from '../../../hooks/useActivityApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ActivityDTO } from '../../../services/apiClient';

const ActivityEdit: React.FC = () => {
  const { getById, edit } = useActivityApi();
  const [entityData, setEntityData] = useState<ActivityDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activities', href: '/admin/activities' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Activity data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate(-1);
    } catch (error) {
      console.error('Error updating Activity:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activities"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission="Manage.Activity.Edit"
    >
      {entityData ? (
        <ActivityForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate(-1)}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ActivityEdit;
